<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pull-left">
        <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
          <i class="ti-arrow-left"></i>
          {{ $t('general.back') }}
        </a>
      </div>
      <p  class="clearfix"></p>
      <group-form :route="route" @on-submit="onOfferSubmit"></group-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import GroupForm from './GroupForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      GroupForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        offerModel: {},
        offer: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onOfferSubmit (model, isValid) {
        this.offerModel = model
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Offers/Group/GroupAdd.vue